import { useMixpanel } from '@/hooks/use-mixpanel';
import { Box } from '@chakra-ui/react';
import { useState } from 'react';

import { EmailView } from './email';
import { LiConnectionView } from './linkedin/connection';
import { LiInMailView } from './linkedin/inmail';

const ComponentMap = new Map([
  ['email', EmailView],
  ['li_connection', LiConnectionView],
  ['li_inmail', LiInMailView],
]);

export const Steps = ({ blueprint = {} }) => {
  const [openStepId, setOpen] = useState(0);
  const { track } = useMixpanel();

  const onOpenBlueprint = (step) => {
    setOpen(step?.id);
    track({
      module: 'mco',
      data: {
        'user-event': 'click',
        'user-action': 'mco-preview-blueprint-step',
      },
    });
  };

  const onCloseBlueprint = () => {
    setOpen(0);
  };

  return (
    <Box
      p="24px"
      background="#F8F8F8"
      height="calc(100% - 80px)"
      overflow="auto"
      backgroundSize="16px 16px"
      borderRadius="0 0 0 32px"
    >
      <Box margin="0 auto" width="798px">
        {blueprint?.outreach?.steps?.map((step, idx) => {
          const Component = ComponentMap.get(step?.channel);
          const isLast = blueprint?.outreach?.steps.length === idx + 1;
          return (
            <Component
              key={step.id}
              blueprint={blueprint}
              isLast={isLast}
              step={step}
              isOpen={openStepId === step?.id}
              onOpen={() => {
                onOpenBlueprint(step);
              }}
              onClose={onCloseBlueprint}
            />
          );
        })}
      </Box>
    </Box>
  );
};
